var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "room3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "inner",
    d: "M 0 0 L 44 0 L 44 20 L 64 20 L 64 44 L 44 44 L 44 64 L 0 64 Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "line1",
    x1: 0,
    x2: 0,
    y1: 64,
    y2: 0,
    stroke: "currentColor",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "line2",
    x1: 0,
    x2: 44,
    y1: 64,
    y2: 64,
    stroke: "currentColor",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "line3",
    x1: 44,
    x2: 44,
    y1: 64,
    y2: 44,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "line4",
    x1: 42.5,
    x2: 64,
    y1: 44,
    y2: 44,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "line5",
    x1: 64,
    x2: 64,
    y1: 44,
    y2: 20,
    stroke: "currentColor",
    strokeWidth: 5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "line6",
    x1: 64,
    x2: 42.5,
    y1: 20,
    y2: 20,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "line7",
    x1: 44,
    x2: 44,
    y1: 20,
    y2: 0,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "line8",
    x1: 44,
    x2: 0,
    y1: 0,
    y2: 0,
    stroke: "currentColor",
    strokeWidth: 5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room3.c1acc40dbbdf3297ed3e03a969caf000.svg";